<template>
  <div>
    <HeroSection />
    <CorePromiseSection />
    <ScenariosSection/>
    <WhyThisMattersSection />    
    <TransparencySection />
    <WaitlistForm />
    <WebsitePackagesSection />
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import CorePromiseSection from "@/components/CorePromiseSection.vue";
import ScenariosSection from "@/components/ScenariosSection.vue";
import WhyThisMattersSection from "@/components/WhyThisMattersSection.vue";
import TransparencySection from "@/components/TransparencySection.vue";
import WaitlistForm from "@/components/WaitlistForm.vue";
import WebsitePackagesSection from "@/components/WebsitePackagesSection.vue";


export default {
  name: "HomeView",
  components: {
    HeroSection,
    CorePromiseSection,
    ScenariosSection,
    WhyThisMattersSection,
    TransparencySection,
    WaitlistForm,
    WebsitePackagesSection
  },
};
</script>
